import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link UpdateTitleCommand}
 */
export interface UpdateTitleCommandProperties extends CommandProperties {
  title: string;
}

/**
 * A command to update the title / name of the database.
 */
export const UpdateTitleCommand = createCommand<UpdateTitleCommandProperties, boolean>(
  'update-title-command'
);
